var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7fadb2d583ddb999e3d90ec6d65ac4c1ff8553f1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["poryadok-ru@sentry"]={id:"7fadb2d583ddb999e3d90ec6d65ac4c1ff8553f1"};
      